export const QUERY_GRAPH_SUCCESS = 'query/runQuery/fulfilled';
export const QUERY_GRAPH_STATUS = 'queryRunnerStatus/setQueryResponseStatus';
export const CLEAR_QUERY_STATUS = 'queryRunnerStatus/clearQueryStatus';
export const GET_AUTH_TOKEN_SUCCESS = 'auth/getAuthTokenSuccess';
export const LOGOUT_SUCCESS = 'auth/signOutSuccess';
export const QUERY_GRAPH_RUNNING = 'query/runQuery/pending';
export const SET_SAMPLE_QUERY_SUCCESS = 'sampleQuery/setSampleQuery';
export const SET_GRAPH_EXPLORER_MODE_SUCCESS = 'graphExplorerMode/setGraphExplorerMode';
export const PROFILE_REQUEST_SUCCESS = 'profile/getProfileInfo/success';
export const PROFILE_REQUEST_ERROR = 'profile/getProfileInfo/error';
export const GET_SNIPPET_SUCCESS = 'snippet/getSnippet/fulfilled';
export const GET_SNIPPET_ERROR = 'snippet/getSnippet/rejected';
export const GET_SNIPPET_PENDING = 'snippet/getSnippet/pending';
export const REMOVE_HISTORY_ITEM_SUCCESS = 'history/removeHistoryItem';
export const ADD_HISTORY_ITEM_SUCCESS = 'history/addHistoryItem';
export const GET_HISTORY_ITEMS_SUCCESS = 'GET_HISTORY_ITEMS_SUCCESS';
export const SAMPLES_FETCH_SUCCESS = 'samples/fetchSamples/fulfilled';
export const SAMPLES_FETCH_ERROR = 'samples/fetchSamples/rejected';
export const SAMPLES_FETCH_PENDING = 'samples/fetchSamples/pending';
export const CHANGE_THEME_SUCCESS = 'CHANGE_THEME_SUCCESS';
export const TOGGLE_SIDEBAR_SUCCESS = 'sidebarProperties/toggleSidebar';
export const CLEAR_TERMS_OF_USE = 'termsOfUse/clearTermsOfUse';
export const FETCH_FULL_SCOPES_SUCCESS = 'scopes/fetchScopes/fulfilled';
export const FETCH_URL_SCOPES_SUCCESS = 'scopes/fetchScopes/fulfilled';
export const FETCH_SCOPES_ERROR = 'scopes/fetchScopes/error';
export const FETCH_FULL_SCOPES_PENDING = 'scopes/fetchScopes/pending';
export const FETCH_URL_SCOPES_PENDING = 'scopes/fetchScopes/pending';
export const GET_CONSENTED_SCOPES_SUCCESS = 'auth/getConsentedScopesSuccess';
export const GET_CONSENTED_SCOPES_ERROR = 'auth/consentToScopes/rejected';
export const GET_CONSENTED_SCOPES_PENDING = 'auth/consentToScopes/pending';
export const GET_CONSENTED_SCOPES_FULFILLED = 'auth/consentToScopes/fulfilled';
export const SET_DEVX_API_URL_SUCCESS = 'devxApi/setDevxApiUrl';
export const REMOVE_ALL_HISTORY_ITEMS_SUCCESS = 'history/removeAllHistoryItems';
export const AUTOCOMPLETE_FETCH_SUCCESS = 'autoComplete/fetch/fulfilled';
export const AUTOCOMPLETE_FETCH_ERROR = 'autoComplete/fetch/rejected';
export const AUTOCOMPLETE_FETCH_PENDING = 'autoComplete/fetch/pending';
export const RESIZE_SUCCESS = 'dimensions/setDimensions';
export const RESPONSE_EXPANDED = 'responseAreaExpanded/expandResponseArea';
export const PERMISSIONS_PANEL_OPEN = 'PERMISSIONS_PANEL_OPEN';
export const AUTHENTICATION_PENDING = 'auth/setAuthenticationPending';
export const FETCH_RESOURCES_SUCCESS = 'resources/fetchResources/fulfilled';
export const FETCH_RESOURCES_ERROR = 'resources/fetchResources/rejected';
export const FETCH_RESOURCES_PENDING = 'resources/fetchResources/pending';
export const GET_GRAPH_PROXY_URL_PENDING = 'proxyUrl/getGraphProxyUrl/pending';
export const GET_GRAPH_PROXY_URL_SUCCESS = 'proxyUrl/getGraphProxyUrl/fulfilled';
export const GET_GRAPH_PROXY_URL_ERROR = 'proxyUrl/getGraphProxyUrl/rejected';
export const SET_GRAPH_PROXY_URL = 'proxyUrl/setGraphProxyUrl';
export const RESOURCEPATHS_ADD_SUCCESS = 'collections/addResourcePaths';
export const RESOURCEPATHS_DELETE_SUCCESS = 'collections/removeResourcePaths';
export const BULK_ADD_HISTORY_ITEMS_SUCCESS = 'history/bulkAddHistoryItems';
export const SET_SNIPPET_TAB_SUCCESS = 'SET_SNIPPET_TAB_SUCCESS';
export const GET_ALL_PRINCIPAL_GRANTS_PENDING = 'permissionGrants/getAllPrincipalGrants/pending';
export const GET_ALL_PRINCIPAL_GRANTS_SUCCESS = 'permissionGrants/getAllPrincipalGrants/fulfilled';
export const GET_ALL_PRINCIPAL_GRANTS_ERROR = 'permissionGrants/getAllPrincipalGrants/rejected';
export const REVOKE_SCOPES_PENDING = 'auth/revokeScopes/pending';
export const REVOKE_SCOPES_SUCCESS = 'auth/revokeScopes/fulfilled';
export const REVOKE_SCOPES_ERROR = 'auth/revokeScopes/rejected';
export const COLLECTION_CREATE_SUCCESS = 'collections/createCollection';
export const SET_BANNER_STATE = 'banner/setBannerState';
